/* Dispatch clock and delivery estimate shared by every surface: the product page (assets/tc-pdp.js and the [data-tc-eta] line under
   Add to cart), the landing pages' buy box and sticky bar, the cart drawer (assets/tc-cart.js) and the header bar.
   Rule: orders placed by 14:00 America/New_York on a business day ship that day; otherwise the next business day.
   Business day = Monday to Friday, not a US federal holiday (observed dates). The calendar covers 2026 and 2027 only: outside
   it, text() returns the generic line and eta() returns null rather than a day it can't prove. Add the next year's dates before 2028.
   Arrival = ship date + 2 to 4 business days on the same calendar. Calibrated 2026-10-12 on 27 delivered web orders (cutoff-adjusted
   ship date to delivery: p15 2, median 3, p85 4 business days); see storefront-upgrade-2026-09-29/home-search-eta-2026-10-12/data. */
(function (g) {
  'use strict';
  var HOLIDAYS = {
    '2026-01-01': "New Year's Day", '2026-01-19': 'Martin Luther King Jr. Day', '2026-02-16': "Presidents' Day",
    '2026-05-25': 'Memorial Day', '2026-06-19': 'Juneteenth', '2026-07-03': 'Independence Day (observed)',
    '2026-09-07': 'Labor Day', '2026-10-12': 'Columbus Day', '2026-11-11': 'Veterans Day',
    '2026-11-26': 'Thanksgiving Day', '2026-12-25': 'Christmas Day',
    '2027-01-01': "New Year's Day", '2027-01-18': 'Martin Luther King Jr. Day', '2027-02-15': "Presidents' Day",
    '2027-05-31': 'Memorial Day', '2027-06-18': 'Juneteenth (observed)', '2027-07-05': 'Independence Day (observed)',
    '2027-09-06': 'Labor Day', '2027-10-11': 'Columbus Day', '2027-11-11': 'Veterans Day',
    '2027-11-25': 'Thanksgiving Day', '2027-12-24': 'Christmas Day (observed)', '2027-12-31': "New Year's Day 2028 (observed)"
  };
  var FIRST = 2026, LAST = 2027, CUTOFF = 50400, ARRIVE_MIN = 2, ARRIVE_MAX = 4;
  var GENERIC = 'Ships same business day when ordered by 2pm ET';
  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var DY = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MO = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function key(y, m, d) { return y + '-' + pad(m) + '-' + pad(d); }
  function wday(y, m, d) { return new Date(Date.UTC(y, m - 1, d)).getUTCDay(); }
  function isBusinessDay(y, m, d) {
    var wd = wday(y, m, d);
    return wd >= 1 && wd <= 5 && !HOLIDAYS[key(y, m, d)];
  }
  function addDays(y, m, d, n) {
    var t = new Date(Date.UTC(y, m - 1, d + n));
    return [t.getUTCFullYear(), t.getUTCMonth() + 1, t.getUTCDate()];
  }
  function etParts(now) {
    var parts;
    try {
      parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hourCycle: 'h23' }).formatToParts(now);
    } catch (e) { return null; }
    var p = {};
    for (var k = 0; k < parts.length; k++) { p[parts[k].type] = parts[k].value; }
    var r = { y: +p.year, m: +p.month, d: +p.day, secs: (parseInt(p.hour, 10) % 24) * 3600 + parseInt(p.minute, 10) * 60 + parseInt(p.second, 10) };
    return (isNaN(r.y) || isNaN(r.m) || isNaN(r.d) || isNaN(r.secs)) ? null : r;
  }
  /* The ship date for an order placed at `now`, as {y, m, d, today, days} (days = calendar days from today), or null when
     the calendar can't prove it (outside FIRST..LAST, or no Intl time zone support). */
  function shipDate(now) {
    var t = etParts(now);
    if (!t || t.y < FIRST || t.y > LAST) { return null; }
    if (isBusinessDay(t.y, t.m, t.d) && t.secs < CUTOFF) { return { y: t.y, m: t.m, d: t.d, today: true, days: 0, secsLeft: CUTOFF - t.secs }; }
    for (var i = 1; i <= 10; i++) {
      var n = addDays(t.y, t.m, t.d, i);
      if (n[0] > LAST) { return null; }
      if (isBusinessDay(n[0], n[1], n[2])) { return { y: n[0], m: n[1], d: n[2], today: false, days: i }; }
    }
    return null;
  }
  function addBusinessDays(y, m, d, n) {
    var c = [y, m, d], k = 0;
    for (var i = 1; i <= 30 && k < n; i++) {
      c = addDays(y, m, d, i);
      if (c[0] > LAST) { return null; }
      if (isBusinessDay(c[0], c[1], c[2])) { k++; }
    }
    return k === n ? c : null;
  }
  function left(secs) {
    var mins = Math.ceil(secs / 60);
    return mins >= 60 ? Math.floor(mins / 60) + 'h ' + (mins % 60) + 'm' : mins + 'm';
  }
  function text(now) {
    var s = shipDate(now || new Date());
    if (!s) { return GENERIC; }
    if (s.today) { return 'Ships today if ordered by 2pm ET (order within ' + left(s.secsLeft) + ')'; }
    if (s.days === 1) { return 'Ships tomorrow'; }
    return 'Ships ' + DAYS[wday(s.y, s.m, s.d)];
  }
  function day(c) { return DY[wday(c[0], c[1], c[2])] + ', ' + MO[c[1] - 1] + ' ' + c[2]; }
  /* Delivery estimate for an order placed at `now`: {lead, range, tiny, text, ship, early, late} or null (same limits as shipDate). */
  function eta(now) {
    var s = shipDate(now || new Date());
    if (!s) { return null; }
    var e = addBusinessDays(s.y, s.m, s.d, ARRIVE_MIN), l = addBusinessDays(s.y, s.m, s.d, ARRIVE_MAX);
    if (!e || !l) { return null; }
    var lead = s.today ? 'Order within ' + left(s.secsLeft) : (s.days === 1 ? 'Ships tomorrow' : 'Ships ' + DAYS[wday(s.y, s.m, s.d)]);
    var range = day(e) + ' – ' + day(l);
    var tiny = e[1] === l[1] ? MO[e[1] - 1] + ' ' + e[2] + '–' + l[2] : MO[e[1] - 1] + ' ' + e[2] + ' – ' + MO[l[1] - 1] + ' ' + l[2];
    return { lead: lead, range: range, tiny: tiny, text: lead + ' · arrives ' + range, ship: [s.y, s.m, s.d], early: e, late: l, today: s.today };
  }
  var MODES = {
    full: function (x) { return x.text; },
    range: function (x) { return 'Arrives ' + x.range; },
    lead: function (x) { return x.lead + ' · free standard shipping'; },
    tiny: function (x) { return 'Arrives ' + x.tiny; },
    sticky: function (x) { return 'Arrives ' + x.tiny + ' · '; },
    bar: function (x) { return 'arrives ' + x.tiny; }
  };
  function paint(root) {
    if (typeof document === 'undefined') { return; }
    var x = eta(new Date());
    if (!x) { return; }
    var els = (root || document).querySelectorAll('[data-tc-eta]');
    for (var i = 0; i < els.length; i++) {
      var f = MODES[els[i].getAttribute('data-tc-eta')] || MODES.full, t = f(x);
      if (els[i].textContent !== t) { els[i].textContent = t; }
    }
  }
  var api = { text: text, shipDate: shipDate, eta: eta, paint: paint, isBusinessDay: isBusinessDay, holidays: HOLIDAYS, generic: GENERIC };
  g.tcDispatch = api;
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; }
  if (typeof document !== 'undefined' && document.querySelectorAll) {
    var run = function () { paint(); };
    run();
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); }
    setInterval(run, 30000);
    document.addEventListener('visibilitychange', run);
    g.addEventListener && g.addEventListener('pageshow', run);
    var watch = function () {
      var b = document.querySelector('[data-tc-cd-body]');
      if (b && g.MutationObserver) { new MutationObserver(function () { paint(b); }).observe(b, { childList: true, subtree: true }); }
    };
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', watch); } else { watch(); }
  }
})(typeof window !== 'undefined' ? window : this);
